import React, { useEffect } from 'react'
import { App as AntApp, ConfigProvider } from 'antd'
import { QueryClient, QueryClientProvider } from 'react-query'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import { Router } from '@/router'

import { antdTheme } from './styles/antd-theme'
import { resources } from './intl/resources'
import '@/styles/global.scss'
import { initializeTracking, trackEvent } from './utils/analytics'

const queryClient = new QueryClient()

export const LANGUAGE_STORAGE_KEY = 'app_language'

const detectLng = () => {
  // Check localStorage first
  const storedLang = localStorage.getItem(LANGUAGE_STORAGE_KEY)
  if (storedLang === 'en' || storedLang === 'es') {
    return storedLang
  }

  // Fall back to browser language
  const lang = (navigator.language || 'en').toLowerCase()
  const base = lang.split('-')[0]
  return base === 'es' ? 'es' : 'en'
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: detectLng(),
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    load: 'languageOnly',
    interpolation: { escapeValue: false },
  })

const initializeGoogleAnalytics = () => {
  initializeTracking()
  trackEvent('Google Analytics', 'Initialized')
}

export const App: React.FC = () => {
  useEffect(() => {
    initializeGoogleAnalytics()
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider theme={antdTheme}>
        {/*
          Phase 132 Plan 01 (Task 4) — <App> from antd silences the
          [antd: Modal] / [antd: message] static-context console warnings
          by giving the static APIs a host that consumes the dynamic
          ConfigProvider theme. Existing Modal.confirm() / message.xxx()
          call sites continue to work unchanged; migrating them to
          App.useApp() hooks is intentionally out of scope.
        */}
        <AntApp>
          <Router />
        </AntApp>
      </ConfigProvider>
    </QueryClientProvider>
  )
}
